import type { ReactNode } from 'react';
import { cn } from '../cn';

export interface StatProps {
  label: string;
  value: ReactNode;
  delta?: { value: string; positive?: boolean };
  caption?: ReactNode;
  className?: string;
}

/** Variante compacta de métrica — usado em barras horizontais e KPIs densos. */
export function Stat({ label, value, delta, caption, className }: StatProps) {
  return (
    <div className={cn('flex flex-col gap-1', className)}>
      <span className="text-2xs text-ink-500 font-semibold uppercase tracking-wider">{label}</span>
      <span className="text-ink-900 font-mono text-xl font-semibold tabular-nums">{value}</span>
      {delta && (
        <span
          className={cn(
            'text-xs font-medium',
            delta.positive ? 'text-success-500' : 'text-danger-500',
          )}
        >
          {delta.positive ? '↑' : '↓'} {delta.value}
        </span>
      )}
      {caption && <span className="text-ink-500 text-xs">{caption}</span>}
    </div>
  );
}
